import * as React from 'react';
import classNames from 'classnames';
import * as Classes from '../common/classes';
import { ButtonToolbar } from '../button-toolbar/ButtonToolbar';
import { BaseProps } from '../common/props';

type Props = BaseProps & {
  // Class name pro footer
  wrapperClassName?: string;
  extra?: React.ReactNode;
  /**
   * Pokud je true, tak se nepředpokládají tlačítka na první úrovni ve footeru - v tuto chvíli není obsah footeru obalen komponentou ButtonToolbar.
   */
  noButtonToolbar?: boolean;
};

export const DialogFooter: React.FC<Props> = ({
  wrapperClassName,
  extra,
  className,
  style,
  children,
  noButtonToolbar,
}) => {
  let wrapperCls = classNames(
    wrapperClassName,
    className,
    Classes.DIALOG_FOOTER
  );

  return (
    <div className={wrapperCls} style={style}>
      <div className={Classes.DIALOG_FOOTER_EXTRA}>{extra}</div>
      <div className={Classes.DIALOG_FOOTER_ACTIONS}>
        {noButtonToolbar ? children : <ButtonToolbar>{children}</ButtonToolbar>}
      </div>
    </div>
  );
};
